module.exports = __webpack_public_path__ + "static/media/wild-spells.aafc3090.gif";